import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  withRouter,
} from 'react-router-dom';
import { HelpRootPath } from 'utils/constants/routes';
import FatsomaTabbLogo from 'utils/images/fatsoma-tabb-logo.svg';
import './index.scss';
import StarConnect from './StarConnect';

const Help = () => {
  return (
    <div className="help__page__container">
      <div className="help__nav__bar">
        <img src={FatsomaTabbLogo} alt="Logo" className="help__logo" />
        <h3 style={{ padding: 0, margin: 0, color: 'white' }}>Help Center</h3>
      </div>

      <div className="help__page__content">
        <Router>
          <Switch>
            <Route
              path={`${HelpRootPath}/star-connect`}
              component={StarConnect}
            />
          </Switch>
        </Router>
      </div>
    </div>
  );
};

export default withRouter(Help);



// WEBPACK FOOTER //
// ./src/components/Help/index.jsx